import axios from 'axios'
import connom from './common'
import avatar from '@/assets/loading.gif'
let publish = process.env.config
let apiurl = process.env.config.baseUrl
axios.defaults.baseURL = publish.baseUrl // 根目录地址
axios.defaults.timeout = 600000 // 超时响应
axios.interceptors.request.use(
  config => {
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    config.headers = {
      // 'Content-Type': 'application/json'
      'Authorization': 'Bearer ' + window.localStorage.getItem('TaToken')
      // 'AppId': window.sessionStorage.getItem('AppId')
    }
    if (config.url.indexOf('?') >= 0) {
      config.url = config.url + '&t=' + new Date().getTime()
    } else {
      config.url = config.url + '?t=' + new Date().getTime()
    }
    // console.log(config.url)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
let userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
let mobile = !!userAgent.match(/AppleWebKit.*Mobile.*/) // 是否为移动终端
export default {
  get (url, noCover) {
    return new Promise((resolve, reject) => {
      if (!noCover) {
        coverGif()
      }
      axios.get(url)
        .then(response => {
          if (!noCover) {
            disCover()
          }
          if (response.data.isSuccess) {
            resolve(response.data.datas || response.data.data)
          } else {
            if (response.data) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: response.data.message,
                stayTime: 5
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
          disCover()
          if (err.response){
            if (err.response.status === 401 || err.response.status === 402) {
              window.localStorage.removeItem('TaToken')
              // let isEmployee = window.localStorage.getItem('isEmployee')
              // if (isEmployee && isEmployee === 'true') {
              //   let openId = window.localStorage.getItem('openId')
              //   this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
              //     console.log(res, 'unbindEmployee')
              //     window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))
              //   })
              // } else {
              //   // alert('1')
              //   window.location.href = ('//' + window.location.host + '/login')
              // }
              if (mobile) {
                let openId = window.localStorage.getItem('openId')
                this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
                  console.log(res, 'unbindEmployee')
                  if(window.location.href.indexOf('articalCollections') >= 0 && window.location.href.indexOf('NewerTag') === -1){
                       let url = apiurl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections')
                        window.location.href = url
                  }else{
                    let html = '&needReturn=true'
                    if (window.location.href.indexOf('mobileSurvey') >= 0) {
                      html += '&noQRcode=true'
                    }
                    window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href)) + html
                  }

                  
                })
                window.localStorage.removeItem('appId')
                window.localStorage.removeItem('openId')
                window.localStorage.removeItem('isEmployee')
                setTimeout(p => {
                  // window.location.reload()
                }, 10)
              } else {
                // alert('1')
                window.location.href = ('//' + window.location.host + '/login')
              }
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }
          } else {
            if (mobile){
              if (err.code){
                return window.location.href = ('//' + window.location.host + '/errPage')
              } else {
                return reject(err)
              }
            }
            if(err.code == 'ECONNABORTED' && err.message.indexOf('timeout')!=-1) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '网络超时, 请重新请求',
                stayTime: 5
              })
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }

          }
          reject(err)
        })
    })
  },
  getNoRes (url) {
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          console.log(err)
          disCover()
          if (err.response){
            if (err.response.status === 401 || err.response.status === 402) {
              window.localStorage.removeItem('TaToken')
              // let isEmployee = window.localStorage.getItem('isEmployee')
              // if (isEmployee && isEmployee === 'true') {
              //   let openId = window.localStorage.getItem('openId')
              //   this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
              //     console.log(res, 'unbindEmployee')
              //     window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))
              //   })
              // } else {
              //   // alert('1')
              //   window.location.href = ('//' + window.location.host + '/login')
              // }
              if (mobile) {
                let openId = window.localStorage.getItem('openId')
                this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
                  console.log(res, 'unbindEmployee')
                  
                  if(window.location.href.indexOf('articalCollections') >= 0 && window.location.href.indexOf('NewerTag') === -1){
                    let url = apiurl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections')
                     window.location.href = url
               }else{
                 let html = '&needReturn=true'
                 if (window.location.href.indexOf('mobileSurvey') >= 0) {
                   html += '&noQRcode=true'
                 }
                 window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href)) + html
               }
                })
                window.localStorage.removeItem('appId')
                window.localStorage.removeItem('openId')
                window.localStorage.removeItem('isEmployee')
                setTimeout(p => {
                  // window.location.reload()
                }, 10)
              } else {
                // alert('1')
                window.location.href = ('//' + window.location.host + '/login')
              }
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }
          } else {
            if (mobile){
              if (err.code){
                return window.location.href = ('//' + window.location.host + '/errPage')
              } else {
                return reject(err)
              }
            }
            if(err.code == 'ECONNABORTED' && err.message.indexOf('timeout')!=-1) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '网络超时, 请重新请求',
                stayTime: 5
              })
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }

          }
          reject(err)
        })
    })
  },
  getList (url) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.get(url)
        .then(response => {
          disCover()
          if (response.data.isSuccess) {
            resolve(response.data || response.data)
          } else {
            if (response.data) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: response.data.message,
                stayTime: 5
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
          disCover()
          if (err.response){
            if (err.response.status === 401 || err.response.status === 402) {
              window.localStorage.removeItem('TaToken')
              // let isEmployee = window.localStorage.getItem('isEmployee')
              // if (isEmployee && isEmployee === 'true') {
              //   let openId = window.localStorage.getItem('openId')
              //   this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
              //     console.log(res, 'unbindEmployee')
              //     window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))
              //   })
              // } else {
              //   // alert('1')
              //   window.location.href = ('//' + window.location.host + '/login')
              // }
              if (mobile) {
                let openId = window.localStorage.getItem('openId')
                this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
                  console.log(res, 'unbindEmployee')
                  if(window.location.href.indexOf('articalCollections') >= 0 && window.location.href.indexOf('NewerTag') === -1){
                    let url = apiurl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections')
                     window.location.href = url
               }else{
                 let html = '&needReturn=true'
                 if (window.location.href.indexOf('mobileSurvey') >= 0) {
                   html += '&noQRcode=true'
                 }
                 window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href)) + html
               }
                })
                window.localStorage.removeItem('appId')
                window.localStorage.removeItem('openId')
                window.localStorage.removeItem('isEmployee')
                setTimeout(p => {
                  // window.location.reload()
                }, 10)
              } else {
                // alert('1')
                window.location.href = ('//' + window.location.host + '/login')
              }
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }
          } else {
            if (mobile){
              if (err.code){
                return window.location.href = ('//' + window.location.host + '/errPage')
              } else {
                return reject(err)
              }
            }
            if(err.code == 'ECONNABORTED' && err.message.indexOf('timeout')!=-1) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '网络超时, 请重新请求',
                stayTime: 5
              })
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }

          }
          reject(err)
        })
    })
  },
  post (url, data,hindloading) {
    return new Promise((resolve, reject) => {
      if(!hindloading){
        coverGif()
      }
      
      axios.post(url, data)
        .then(response => {
          
          if (response.data.isSuccess) {
            if(!hindloading){
              disCover()
            }
            
            resolve(response.data.datas || response.data.data)
          } else {
            if(!hindloading){
              disCover()
            }
            if (response.data) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: response.data.message,
                stayTime: 5
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
          if(!hindloading){
            disCover()
          }
          if (err.response){
            if (err.response.status === 401 || err.response.status === 402) {
              window.localStorage.removeItem('TaToken')
              // let isEmployee = window.localStorage.getItem('isEmployee')
              // if (isEmployee && isEmployee === 'true') {
              //   let openId = window.localStorage.getItem('openId')
              //   this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
              //     console.log(res, 'unbindEmployee')
              //     window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))
              //   })
              // } else {
              //   // alert('1')
              //   window.location.href = ('//' + window.location.host + '/login')
              // }
              if (mobile) {
                let openId = window.localStorage.getItem('openId')
                this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
                  console.log(res, 'unbindEmployee')
                  if(window.location.href.indexOf('articalCollections') >= 0 && window.location.href.indexOf('NewerTag') === -1){
                    let url = apiurl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections')
                     window.location.href = url
               }else{
                 let html = '&needReturn=true'
                 if (window.location.href.indexOf('mobileSurvey') >= 0) {
                   html += '&noQRcode=true'
                 }
                 window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href)) + html
               }
                })
                window.localStorage.removeItem('appId')
                window.localStorage.removeItem('openId')
                window.localStorage.removeItem('isEmployee')
                setTimeout(p => {
                  // window.location.reload()
                }, 10)
              } else {
                // alert('1')
                window.location.href = ('//' + window.location.host + '/login')
              }
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }
          } else {
            if (mobile){
              if (err.code){
                return window.location.href = ('//' + window.location.host + '/errPage')
              } else {
                return reject(err)
              }
            }
            if(err.code == 'ECONNABORTED' && err.message.indexOf('timeout')!=-1) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '网络超时, 请重新请求',
                stayTime: 5
              })
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }

          }
          reject(err)
        })
    })
  },
  postForUser (url, data) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.post(url, data)
        .then(response => {
          disCover()
          if (response.data.isSuccess) {
            resolve(response.data)
          } else {
            if (response.data) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: response.data.message,
                stayTime: 5
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
          disCover()
          if (err.response){
            if (err.response.status === 401 || err.response.status === 402) {
              window.localStorage.removeItem('TaToken')
              // let isEmployee = window.localStorage.getItem('isEmployee')
              // if (isEmployee && isEmployee === 'true') {
              //   let openId = window.localStorage.getItem('openId')
              //   this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
              //     console.log(res, 'unbindEmployee')
              //     window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))
              //   })
              // } else {
              //   // alert('1')
              //   window.location.href = ('//' + window.location.host + '/login')
              // }
              if (mobile) {
                let openId = window.localStorage.getItem('openId')
                this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
                  console.log(res, 'unbindEmployee')
                  if(window.location.href.indexOf('articalCollections') >= 0 && window.location.href.indexOf('NewerTag') === -1){
                    let url = apiurl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections')
                     window.location.href = url
               }else{
                 let html = '&needReturn=true'
                 if (window.location.href.indexOf('mobileSurvey') >= 0) {
                   html += '&noQRcode=true'
                 }
                 window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href)) + html
               }
                })
                window.localStorage.removeItem('appId')
                window.localStorage.removeItem('openId')
                window.localStorage.removeItem('isEmployee')
                setTimeout(p => {
                  // window.location.reload()
                }, 10)
              } else {
                // alert('1')
                window.location.href = ('//' + window.location.host + '/login')
              }
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }
          } else {
            if (mobile){
              if (err.code){
                return window.location.href = ('//' + window.location.host + '/errPage')
              } else {
                return reject(err)
              }
            }
            if(err.code == 'ECONNABORTED' && err.message.indexOf('timeout')!=-1) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '网络超时, 请重新请求',
                stayTime: 5
              })
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }

          }
          reject(err)
        })
    })
  },
  postForUE (url, data) {
    return new Promise((resolve, reject) => {
      axios.post(url, data)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  postNoRes (url, data) {
    return new Promise((resolve, reject) => {
      axios.post(url, data)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          console.log(err)
          disCover()
          if (err.response){
            if (err.response.status === 401 || err.response.status === 402) {
              window.localStorage.removeItem('TaToken')
              // let isEmployee = window.localStorage.getItem('isEmployee')
              // if (isEmployee && isEmployee === 'true') {
              //   let openId = window.localStorage.getItem('openId')
              //   this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
              //     console.log(res, 'unbindEmployee')
              //     window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))
              //   })
              // } else {
              //   // alert('1')
              //   window.location.href = ('//' + window.location.host + '/login')
              // }
              if (mobile) {
                let openId = window.localStorage.getItem('openId')
                this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
                  console.log(res, 'unbindEmployee')
                  if(window.location.href.indexOf('articalCollections') >= 0 && window.location.href.indexOf('NewerTag') === -1){
                    let url = apiurl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections')
                     window.location.href = url
               }else{
                 let html = '&needReturn=true'
                 if (window.location.href.indexOf('mobileSurvey') >= 0) {
                   html += '&noQRcode=true'
                 }
                 window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href)) + html
               }
                })
                window.localStorage.removeItem('appId')
                window.localStorage.removeItem('openId')
                window.localStorage.removeItem('isEmployee')
                setTimeout(p => {
                  // window.location.reload()
                }, 10)
              } else {
                // alert('1')
                window.location.href = ('//' + window.location.host + '/login')
              }
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }
          } else {
            if (mobile){
              if (err.code){
                return window.location.href = ('//' + window.location.host + '/errPage')
              } else {
                return reject(err)
              }
            }
            if(err.code == 'ECONNABORTED' && err.message.indexOf('timeout')!=-1) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '网络超时, 请重新请求',
                stayTime: 5
              })
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }

          }
          reject(err)
        })
    })
  },
  put (url, data) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.put(url, data)
        .then(response => {
          disCover()
          if (response.data.isSuccess) {
            resolve(response.data.datas || response.data.data)
          } else {
            if (response.data) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: response.data.message,
                stayTime: 5
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
          disCover()
          if (err.response){
            if (err.response.status === 401 || err.response.status === 402) {
              window.localStorage.removeItem('TaToken')
              // let isEmployee = window.localStorage.getItem('isEmployee')
              // if (isEmployee && isEmployee === 'true') {
              //   let openId = window.localStorage.getItem('openId')
              //   this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
              //     console.log(res, 'unbindEmployee')
              //     window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))
              //   })
              // } else {
              //   // alert('1')
              //   window.location.href = ('//' + window.location.host + '/login')
              // }
              if (mobile) {
                let openId = window.localStorage.getItem('openId')
                this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
                  console.log(res, 'unbindEmployee')
                  if(window.location.href.indexOf('articalCollections') >= 0 && window.location.href.indexOf('NewerTag') === -1){
                    let url = apiurl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections')
                     window.location.href = url
               }else{
                 let html = '&needReturn=true'
                 if (window.location.href.indexOf('mobileSurvey') >= 0) {
                   html += '&noQRcode=true'
                 }
                 window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href)) + html
               }
                })
                window.localStorage.removeItem('appId')
                window.localStorage.removeItem('openId')
                window.localStorage.removeItem('isEmployee')
                setTimeout(p => {
                  // window.location.reload()
                }, 10)
              } else {
                // alert('1')
                window.location.href = ('//' + window.location.host + '/login')
              }
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }
          } else {
            if (mobile){
              if (err.code){
                return window.location.href = ('//' + window.location.host + '/errPage')
              } else {
                return reject(err)
              }
            }
            if(err.code == 'ECONNABORTED' && err.message.indexOf('timeout')!=-1) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '网络超时, 请重新请求',
                stayTime: 5
              })
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }

          }
          reject(err)
        })
    })
  },
  patch (url, data) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.patch(url, data)
        .then(response => {
          disCover()
          if (response.data.isSuccess) {
            resolve(response.data.datas || response.data.data)
          } else {
            if (response.data) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: response.data.message,
                stayTime: 5
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
          disCover()
          if (err.response){
            if (err.response.status === 401 || err.response.status === 402) {
              window.localStorage.removeItem('TaToken')
              // let isEmployee = window.localStorage.getItem('isEmployee')
              // if (isEmployee && isEmployee === 'true') {
              //   let openId = window.localStorage.getItem('openId')
              //   this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
              //     console.log(res, 'unbindEmployee')
              //     window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))
              //   })
              // } else {
              //   // alert('1')
              //   window.location.href = ('//' + window.location.host + '/login')
              // }
              if (mobile) {
                let openId = window.localStorage.getItem('openId')
                this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
                  console.log(res, 'unbindEmployee')
                  if(window.location.href.indexOf('articalCollections') >= 0 && window.location.href.indexOf('NewerTag') === -1){
                    let url = apiurl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections')
                     window.location.href = url
               }else{
                 let html = '&needReturn=true'
                 if (window.location.href.indexOf('mobileSurvey') >= 0) {
                   html += '&noQRcode=true'
                 }
                 window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href)) + html
               }
                })
                window.localStorage.removeItem('appId')
                window.localStorage.removeItem('openId')
                window.localStorage.removeItem('isEmployee')
                setTimeout(p => {
                  // window.location.reload()
                }, 10)
              } else {
                // alert('1')
                window.location.href = ('//' + window.location.host + '/login')
              }
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }
          } else {
            if (mobile){
              if (err.code){
                return window.location.href = ('//' + window.location.host + '/errPage')
              } else {
                return reject(err)
              }
            }
            if(err.code == 'ECONNABORTED' && err.message.indexOf('timeout')!=-1) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '网络超时, 请重新请求',
                stayTime: 5
              })
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }

          }
          reject(err)
        })
    })
  },
  del (url) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.delete(url)
        .then(response => {
          disCover()
          if (response.data.isSuccess) {
            resolve(response.data.datas || response.data.data)
          } else {
            if (response.data) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: response.data.message,
                stayTime: 5
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
          disCover()
          if (err.response){
            if (err.response.status === 401 || err.response.status === 402) {
              window.localStorage.removeItem('TaToken')
              // let isEmployee = window.localStorage.getItem('isEmployee')
              // if (isEmployee && isEmployee === 'true') {
              //   let openId = window.localStorage.getItem('openId')
              //   this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
              //     console.log(res, 'unbindEmployee')
              //     window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))
              //   })
              // } else {
              //   // alert('1')
              //   window.location.href = ('//' + window.location.host + '/login')
              // }
              if (mobile) {
                let openId = window.localStorage.getItem('openId')
                this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
                  console.log(res, 'unbindEmployee')
                  if(window.location.href.indexOf('articalCollections') >= 0 && window.location.href.indexOf('NewerTag') === -1){
                    let url = apiurl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections')
                     window.location.href = url
               }else{
                 let html = '&needReturn=true'
                 if (window.location.href.indexOf('mobileSurvey') >= 0) {
                   html += '&noQRcode=true'
                 }
                 window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href)) + html
               }
                })
                window.localStorage.removeItem('appId')
                window.localStorage.removeItem('openId')
                window.localStorage.removeItem('isEmployee')
                setTimeout(p => {
                  // window.location.reload()
                }, 10)
              } else {
                // alert('1')
                window.location.href = ('//' + window.location.host + '/login')
              }
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }
          } else {
            if (mobile){
              if (err.code){
                return window.location.href = ('//' + window.location.host + '/errPage')
              } else {
                return reject(err)
              }
            }
            if(err.code == 'ECONNABORTED' && err.message.indexOf('timeout')!=-1) {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '网络超时, 请重新请求',
                stayTime: 5
              })
            } else {
              connom.alertTips({
                type: 'error',
                title: '错误',
                content: '服务器报错',
                stayTime: 5
              })
            }

          }
          reject(err)
        })
    })
  },
  getNomalData (url) {
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  asyncGet (url) {
    var p = new Promise((resolve, reject) => {
      axios.get(url).then(msg => {
        resolve(msg.data.data)
      })
      .catch(err => {
        console.log(err)
        disCover()
        if (err.response){
          if (err.response.status === 401 || err.response.status === 402) {
            window.localStorage.removeItem('TaToken')
            // let isEmployee = window.localStorage.getItem('isEmployee')
            // if (isEmployee && isEmployee === 'true') {
            //   let openId = window.localStorage.getItem('openId')
            //   this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
            //     console.log(res, 'unbindEmployee')
            //     window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))
            //   })
            // } else {
            //   // alert('1')
            //   window.location.href = ('//' + window.location.host + '/login')
            // }
            if (mobile) {
              let openId = window.localStorage.getItem('openId')
              this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
                console.log(res, 'unbindEmployee')
                if(window.location.href.indexOf('articalCollections') >= 0 && window.location.href.indexOf('NewerTag') === -1){
                  let url = apiurl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections')
                   window.location.href = url
             }else{
               let html = '&needReturn=true'
               if (window.location.href.indexOf('mobileSurvey') >= 0) {
                 html += '&noQRcode=true'
               }
               window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href)) + html
             }
              })
              window.localStorage.removeItem('appId')
              window.localStorage.removeItem('openId')
              window.localStorage.removeItem('isEmployee')
              setTimeout(p => {
                // window.location.reload()
              }, 10)
            } else {
              // alert('1')
              window.location.href = ('//' + window.location.host + '/login')
            }
          } else {
            connom.alertTips({
              type: 'error',
              title: '错误',
              content: '服务器报错',
              stayTime: 5
            })
          }
        } else {
          if (mobile){
            if (err.code){
              return window.location.href = ('//' + window.location.host + '/errPage')
            } else {
              return reject(err)
            }
          }
          if(err.code == 'ECONNABORTED' && err.message.indexOf('timeout')!=-1) {
            connom.alertTips({
              type: 'error',
              title: '错误',
              content: '网络超时, 请重新请求',
              stayTime: 5
            })
          } else {
            connom.alertTips({
              type: 'error',
              title: '错误',
              content: '服务器报错',
              stayTime: 5
            })
          }

        }
        reject(err)
      })
    })
    return p
  },
  asyncGetData (url) {
    var p = new Promise((resolve, reject) => {
      axios.get(url).then(msg => {
        resolve(msg.data)
      })
      .catch(err => {
        console.log(err)
        disCover()
        if (err.response){
          if (err.response.status === 401 || err.response.status === 402) {
            window.localStorage.removeItem('TaToken')
            // let isEmployee = window.localStorage.getItem('isEmployee')
            // if (isEmployee && isEmployee === 'true') {
            //   let openId = window.localStorage.getItem('openId')
            //   this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
            //     console.log(res, 'unbindEmployee')
            //     window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))
            //   })
            // } else {
            //   // alert('1')
            //   window.location.href = ('//' + window.location.host + '/login')
            // }
            if (mobile) {
              let openId = window.localStorage.getItem('openId')
              this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
                console.log(res, 'unbindEmployee')
                if(window.location.href.indexOf('articalCollections') >= 0 && window.location.href.indexOf('NewerTag') === -1){
                  let url = apiurl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections')
                   window.location.href = url
             }else{
               let html = '&needReturn=true'
               if (window.location.href.indexOf('mobileSurvey') >= 0) {
                 html += '&noQRcode=true'
               }
               window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href)) + html
             }
              })
              window.localStorage.removeItem('appId')
              window.localStorage.removeItem('openId')
              window.localStorage.removeItem('isEmployee')
              setTimeout(p => {
                // window.location.reload()
              }, 10)
            } else {
              // alert('1')
              window.location.href = ('//' + window.location.host + '/login')
            }
          } else {
            connom.alertTips({
              type: 'error',
              title: '错误',
              content: '服务器报错',
              stayTime: 5
            })
          }
        } else {
          if (mobile){
            if (err.code){
              return window.location.href = ('//' + window.location.host + '/errPage')
            } else {
              return reject(err)
            }
          }
          if(err.code == 'ECONNABORTED' && err.message.indexOf('timeout')!=-1) {
            connom.alertTips({
              type: 'error',
              title: '错误',
              content: '网络超时, 请重新请求',
              stayTime: 5
            })
          } else {
            connom.alertTips({
              type: 'error',
              title: '错误',
              content: '服务器报错',
              stayTime: 5
            })
          }

        }
        reject(err)
      })
    })
    return p
  },
  asyncPost (url, data) {
    var p = new Promise((resolve, reject) => {
      axios.post(url, data).then(msg => {
        resolve(msg.data.data)
      })
      .catch(err => {
        console.log(err)
        disCover()
        if (err.response){
          if (err.response.status === 401 || err.response.status === 402) {
            window.localStorage.removeItem('TaToken')
            // let isEmployee = window.localStorage.getItem('isEmployee')
            // if (isEmployee && isEmployee === 'true') {
            //   let openId = window.localStorage.getItem('openId')
            //   this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
            //     console.log(res, 'unbindEmployee')
            //     window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))
            //   })
            // } else {
            //   // alert('1')
            //   window.location.href = ('//' + window.location.host + '/login')
            // }
            if (mobile) {
              let openId = window.localStorage.getItem('openId')
              this.post('/api/wechat/EmployeeLoginOut', {openId: openId}).then(res => {
                console.log(res, 'unbindEmployee')
                if(window.location.href.indexOf('articalCollections') >= 0 && window.location.href.indexOf('NewerTag') === -1){
                  let url = apiurl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections')
                   window.location.href = url
             }else{
               let html = '&needReturn=true'
               if (window.location.href.indexOf('mobileSurvey') >= 0) {
                 html += '&noQRcode=true'
               }
               window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href)) + html
             }
              })
              window.localStorage.removeItem('appId')
              window.localStorage.removeItem('openId')
              window.localStorage.removeItem('isEmployee')
              setTimeout(p => {
                // window.location.reload()
              }, 10)
            } else {
              // alert('1')
              window.location.href = ('//' + window.location.host + '/login')
            }
          } else {
            connom.alertTips({
              type: 'error',
              title: '错误',
              content: '服务器报错',
              stayTime: 5
            })
          }
        } else {
          if (mobile){
            if (err.code){
              return window.location.href = ('//' + window.location.host + '/errPage')
            } else {
              return reject(err)
            }
          }
          if(err.code == 'ECONNABORTED' && err.message.indexOf('timeout')!=-1) {
            connom.alertTips({
              type: 'error',
              title: '错误',
              content: '网络超时, 请重新请求',
              stayTime: 5
            })
          } else {
            connom.alertTips({
              type: 'error',
              title: '错误',
              content: '服务器报错',
              stayTime: 5
            })
          }

        }
        reject(err)
      })
    })
    return p
  }
}
function coverGif () {
  if (!document.getElementById('loadingGif')) {
    let dom = document.createElement('div')
    dom.id = 'loadingGif'
    let html = `<img src=${avatar} height="144" width="192"/>`
    // let html = '<img src="' + avatar + '" height="144" width="192"/>'
    dom.innerHTML = html
    document.getElementById('app').appendChild(dom)
  }
}
function disCover () {
  if (document.getElementById('loadingGif')) {
    document.getElementById('app').removeChild(document.getElementById('loadingGif'))
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/axios.js